export default {"src":"/_next/static/media/user-x.7356b8ad.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};